// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-recording-presentation--zCKcs{max-width:1200px;min-height:0}.video-stage-wrapper--ipeaj{min-height:0;min-width:0}.video-stage--KmDa6{position:relative;width:100%;aspect-ratio:16/9}.video-stage--KmDa6>*{position:absolute;inset:0;width:100%;height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"common-recording-presentation": "common-recording-presentation--zCKcs",
	"video-stage-wrapper": "video-stage-wrapper--ipeaj",
	"video-stage": "video-stage--KmDa6"
};
export default ___CSS_LOADER_EXPORT___;
